import type { TenantDTO } from '@propmgt/shared';
import { formatDate, formatRelative } from './date';

/**
 * Portal status for the tenant list (0.26.0) — derived SERVER-side from real evidence (sessions,
 * auth.login audit rows, last_login_at), so a tenant who signed in before last_login_at existed, or
 * who never needed to sign in again, no longer reads "never signed in". Text carries the meaning;
 * the badge class is decoration only.
 */
export function portalStatus(t: TenantDTO, now: Date = new Date()): { label: string; cls: string } {
  const status = t.portalStatus ?? (t.userId ? (t.lastLoginAt ? 'active' : 'invited') : 'not_invited');
  switch (status) {
    case 'not_invited':
      return { label: 'Not invited', cls: 'badge' };
    case 'suspended':
      return { label: 'Suspended', cls: 'badge badge--err' };
    case 'invited':
      return { label: 'Invited · never signed in', cls: 'badge badge--warn' };
    default: {
      const first = t.firstSignInAt ?? t.lastLoginAt ?? null;
      const last = t.lastActiveAt ?? null;
      const label = `Signed in ${formatDate(first)}${last ? ` · last active ${formatRelative(last, now)}` : ''}`;
      return { label, cls: 'badge badge--ok' };
    }
  }
}
